import * as z from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    confirm: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    personalReviews: z.string().min(1),
    personalReviewRfi: z.string().min(1),
    personalSharedDashboards: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountSetup: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountUsers: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    accountChats: z.string().min(1),
    accountMilo: z.string().min(1),
    accountProjects: z.string().min(1),
    accountScheduleOfValues: z.string().min(1),
    accountCostCodes: z.string().min(1),
    accountImportStudio: z.string().min(1),
    accountFieldData: z.string().min(1),
    accountScheduleOfRates: z.string().min(1),
    accountScheduleOfRatesV1: z.string().min(1),
    accountScheduling: z.string().min(1),
    accountSchedulingFatigue: z.string().min(1),
    accountConnect: z.string().min(1),
    accountConnectApprovals: z.string().min(1),
    accountMyShifts: z.string().min(1),
    accountMyShiftsWorkOrder: z.string().min(1),
    accountMyCompetencies: z.string().min(1),
    accountPayrollRates: z.string().min(1),
    accountTimesheets: z.string().min(1),
    accountDockets: z.string().min(1),
    accountSiteDiaries: z.string().min(1),
    accountBillableUnits: z.string().min(1),
    accountOrders: z.string().min(1),
    accountJobCosting: z.string().min(1),
    accountInvoices: z.string().min(1),
    accountReports: z.string().min(1),
    accountReportDashboards: z.string().min(1),
    accountIntegrations: z.string().min(1),
    accountPurchaseOrders: z.string().min(1),
    accountPurchaseOrderQuoteImports: z.string().min(1),
    accountPurchaseRequisitions: z.string().min(1),
    accountPurchaseRequisitionNew: z.string().min(1),
    accountPurchaseRequisition: z.string().min(1),
    accountPurchaseRequisitionEdit: z.string().min(1),
    accountSuppliers: z.string().min(1),
    accountSupplierInvoices: z.string().min(1),
    accountSupplierInvoiceImports: z.string().min(1),
    accountSupplierClaims: z.string().min(1),
    accountSupplierClaim: z.string().min(1),
    accountSupplierTime: z.string().min(1),
    accountSupplierTimeSubmit: z.string().min(1),
    accountProcurementSettings: z.string().min(1),
    accountQuotes: z.string().min(1),
    accountApiKeys: z.string().min(1),
    accountForms: z.string().min(1),
    accountTags: z.string().min(1),
    accountAssets: z.string().min(1),
    accountMaintenance: z.string().min(1),
    accountMaintenanceRequests: z.string().min(1),
    accountMaintenanceWorkOrders: z.string().min(1),
    accountMaintenanceWorkOrder: z.string().min(1),
    accountMaintenanceCosts: z.string().min(1),
    accountMaintenanceReport: z.string().min(1),
    accountMaintenanceUtilisation: z.string().min(1),
    accountRoles: z.string().min(1),
    accountCompetencies: z.string().min(1),
    accountPendingVerifications: z.string().min(1),
    accountMaterials: z.string().min(1),
    accountAllowances: z.string().min(1),
    accountActivities: z.string().min(1),
    accountWorkpacks: z.string().min(1),
    accountDocuments: z.string().min(1),
    accountDocumentDetail: z.string().min(1),
    accountDocumentRevision: z.string().min(1),
    accountVariations: z.string().min(1),
    accountHseq: z.string().min(1),
    accountHseqMyWork: z.string().min(1),
    accountHseqDashboard: z.string().min(1),
    accountHseqActions: z.string().min(1),
    accountHseqConditions: z.string().min(1),
    accountHseqInspections: z.string().min(1),
    accountHseqNew: z.string().min(1),
    accountHseqPermits: z.string().min(1),
    accountHseqSubstances: z.string().min(1),
    accountWorkpacksDelegatedSubstances: z.string().min(1),
    accountHseqPermitNew: z.string().min(1),
    accountHseqPermit: z.string().min(1),
    accountHseqWalks: z.string().min(1),
    accountHseqWalk: z.string().min(1),
    accountHseqMap: z.string().min(1),
    accountHseqStatistics: z.string().min(1),
    accountHseqShared: z.string().min(1),
    accountHseqSharedIssue: z.string().min(1),
    accountWorkpackTemplates: z.string().min(1),
    accountMessaging: z.string().min(1),
    accountSmsInbox: z.string().min(1),
    accountSmsCompose: z.string().min(1),
    accountSmsOutbox: z.string().min(1),
    accountSmsUsage: z.string().min(1),
    accountSmsTemplates: z.string().min(1),
    accountSmsGroups: z.string().min(1),
    accountWorkpackInstances: z.string().min(1),
    accountWorkpacksIncoming: z.string().min(1),
    accountWorkpacksAssigned: z.string().min(1),
    accountWorkpacksDelegated: z.string().min(1),
    accountWorkpacksSettings: z.string().min(1),
    accountWorkpacksOrganisations: z.string().min(1),
    accountSubcontractors: z.string().min(1),
    accountUsage: z.string().min(1),
    supplierOnboarding: z.string().min(1),
    supplierHome: z.string().min(1),
    supplierPurchaseOrders: z.string().min(1),
    supplierInvoices: z.string().min(1),
    supplierPortals: z.string().min(1),
    accountMarketplace: z.string().min(1),
    accountMarketplaceProfile: z.string().min(1),
    accountMarketplaceOfferings: z.string().min(1),
    accountMarketplaceRequests: z.string().min(1),
    accountMarketplacePurchaseOrders: z.string().min(1),
    accountMarketplaceNewRequest: z.string().min(1),
    joinTeam: z.string().min(1),
    workpackOrgLinkAccept: z.string().min(1),
    orgLinkAccept: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    confirm: '/auth/confirm',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
  },
  app: {
    home: '/home',
    // PAY-963 (Task 6 builds the page): the reviewer's personal "My reviews" +
    // org-sharing consent surface. Wired now so Task 5's "Share with your
    // organisation" banner links here and the link/revoke actions'
    // `revalidatePath('/home/reviews')` matches.
    personalReviews: '/home/reviews',
    // PAY-2340: the RFI assignee's respond page, in the PERSONAL context —
    // `${personalReviewRfi}/${workpackId}`. No account slug on purpose: an RFI
    // assignee is routinely a client or supplier with no membership of the
    // owning tenant, so a slug-bearing route would be unreachable for them.
    // This is also the deep link `pay-rfi-notifier.ts` writes into the
    // notification row, and what `respondToWorkpackRfiAction` revalidates
    // (`/home/reviews`) after an answer.
    personalReviewRfi: '/home/reviews/rfi',
    // PAY-1797: cross-account "Shared with me" dashboards surface (viewer
    // records via list_dashboard_shares_for_user; same personal-nav precedent
    // as personalReviews).
    personalSharedDashboards: '/home/shared-dashboards',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    // PAY-3731 / PAY-3738: the guided setup (locations, then coding).
    accountSetup: `/home/[account]/settings/setup`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountUsers: `/home/[account]/users`,
    accountBillingReturn: `/home/[account]/billing/return`,
    accountChats: `/home/[account]/chats`,
    accountMilo: `/home/[account]/milo`,
    accountProjects: `/home/[account]/projects`,
    accountScheduleOfValues: `/home/[account]/schedule-of-values`,
    accountCostCodes: `/home/[account]/cost-codes`,
    accountImportStudio: `/home/[account]/import-studio`,
    accountFieldData: `/home/[account]/field-data`,
    // PAY-2202: V2 (deterministic charge-rules) owns the canonical
    // /schedule-of-rates route. V1 (AI-extraction) lives on -v1 for the legacy
    // accounts still on `sor_version: 'v1'`. The shared module library stays at
    // app/[locale]/home/[account]/schedule-of-rates/_lib (imported by ~22
    // trigger/lib files), which is why only the routable segments moved.
    accountScheduleOfRates: `/home/[account]/schedule-of-rates`,
    accountScheduleOfRatesV1: `/home/[account]/schedule-of-rates-v1`,
    accountScheduling: `/home/[account]/scheduling`,
    accountSchedulingFatigue: `/home/[account]/scheduling/fatigue`,
    accountConnect: `/home/[account]/connect`,
    // PAY-2809 US-4: the Connect Approvals inbox. A STATIC sibling of the
    // builder's optional catch-all (`connect/[[...path]]`), which is what
    // makes every filtered view a refresh-safe deep link — Next.js gives the
    // static segment precedence, the same way `connect/usage` already relies
    // on. This is also the link the approver notification carries.
    accountConnectApprovals: `/home/[account]/connect/approvals`,
    accountMyShifts: `/home/[account]/my-shifts`,
    // The work order a mechanic is booked on, read-only (no money).
    accountMyShiftsWorkOrder: `/home/[account]/my-shifts/work-orders/[orderId]`,
    accountMyCompetencies: `/home/[account]/my-competencies`,
    accountPayrollRates: `/home/[account]/pay-rates`,
    accountTimesheets: `/home/[account]/timesheets`,
    accountDockets: `/home/[account]/dockets`,
    accountSiteDiaries: `/home/[account]/site-diaries`,
    accountBillableUnits: `/home/[account]/billable-units`,
    accountOrders: `/home/[account]/orders`,
    accountJobCosting: `/home/[account]/job-costing`,
    accountInvoices: `/home/[account]/invoices`,
    accountReports: `/home/[account]/reports`,
    accountReportDashboards: `/home/[account]/reports/dashboards`,
    accountIntegrations: `/home/[account]/integrations`,
    accountPurchaseOrders: `/home/[account]/purchase-orders`,
    // PAY-4385: the supplier quote import queue (review at `/<importId>`).
    accountPurchaseOrderQuoteImports: `/home/[account]/purchase-orders/imports`,
    accountPurchaseRequisitions: `/home/[account]/purchase-orders/requisitions`,
    accountPurchaseRequisitionNew: `/home/[account]/purchase-orders/requisitions/new`,
    accountPurchaseRequisition: `/home/[account]/purchase-orders/requisitions/[requisitionId]`,
    accountPurchaseRequisitionEdit: `/home/[account]/purchase-orders/requisitions/[requisitionId]/edit`,
    accountSuppliers: `/home/[account]/suppliers`,
    accountSupplierInvoices: `/home/[account]/supplier-invoices`,
    accountSupplierInvoiceImports: `/home/[account]/supplier-invoices/imports`,
    accountSupplierClaims: `/home/[account]/supplier-invoices/claims`,
    accountSupplierClaim: `/home/[account]/supplier-invoices/claims/[supplierId]`,
    // PAY-4282: the buyer-account supplier portal's time surfaces. Submit
    // resolves (and lazily seeds) the Supplier time form, then redirects to
    // the ordinary form fill page.
    accountSupplierTime: `/home/[account]/supplier-time`,
    accountSupplierTimeSubmit: `/home/[account]/supplier-time/submit`,
    // PAY-2792: absorbed into the settings page. The key is kept so the nav
    // entry and any future caller keep one name for "where procurement
    // settings live".
    //
    // KNOWN TRADE-OFF: `isRouteActive` strips `?` but not `#`, so this row no
    // longer highlights — the fragment never matches a pathname. The
    // alternative, pointing it at the old route, highlights just as rarely
    // (that route redirects away immediately) and costs an extra hop. Two nav
    // rows targeting one page cannot be told apart by pathname either way.
    accountProcurementSettings: `/home/[account]/settings#procurement`,
    accountQuotes: `/home/[account]/quotes`,
    accountApiKeys: `/home/[account]/api-keys`,
    accountForms: `/home/[account]/forms`,
    accountTags: `/home/[account]/tags`,
    accountAssets: `/home/[account]/assets`,
    // PAY-5085 / PAY-5087: Asset Maintenance. The root redirects to requests.
    accountMaintenance: `/home/[account]/maintenance`,
    accountMaintenanceRequests: `/home/[account]/maintenance/requests`,
    accountMaintenanceWorkOrders: `/home/[account]/maintenance/work-orders`,
    accountMaintenanceWorkOrder: `/home/[account]/maintenance/work-orders/[orderId]`,
    // US-11: Maintenance > Costs (a hub tab).
    accountMaintenanceCosts: `/home/[account]/maintenance/costs`,
    // Report a breakdown. Outside the hub's maintenance.view gate: field
    // reaches it with maintenance.request alone (`?asset=` preselects).
    accountMaintenanceReport: `/home/[account]/maintenance/report`,
    // US-65: booked / not used / down per asset, a hub tab.
    accountMaintenanceUtilisation: `/home/[account]/maintenance/utilisation`,
    accountRoles: `/home/[account]/roles`,
    accountCompetencies: `/home/[account]/competencies`,
    accountPendingVerifications: `/home/[account]/compliance/verifications`,
    accountMaterials: `/home/[account]/materials`,
    accountAllowances: `/home/[account]/allowances`,
    accountActivities: `/home/[account]/activities`,
    accountWorkpacks: `/home/[account]/workpacks`,
    accountDocuments: `/home/[account]/documents`,
    accountDocumentDetail: `/home/[account]/documents/[documentId]`,
    accountDocumentRevision: `/home/[account]/documents/[documentId]/revisions/[revisionId]`,
    // PAY-4220: the variation docket register; a docket opens at /variations/[docketId].
    accountVariations: `/home/[account]/variations`,
    // PAY-3338: the issues register. Actions register and raise sit under it.
    accountHseq: `/home/[account]/hseq`,
    accountHseqMyWork: `/home/[account]/hseq/my-work`,
    // PAY-3344: first-class HSEQ dashboard. First tab on the register header.
    accountHseqDashboard: `/home/[account]/hseq/dashboard`,
    accountHseqActions: `/home/[account]/hseq/actions`,
    accountHseqConditions: `/home/[account]/hseq/conditions`,
    accountHseqInspections: `/home/[account]/hseq/inspections`,
    accountHseqNew: `/home/[account]/hseq/new`,
    // PAY-3595: permits register, request/issue, and detail.
    accountHseqPermits: `/home/[account]/hseq/permits`,
    accountHseqSubstances: `/home/[account]/hseq/substances`,
    accountWorkpacksDelegatedSubstances: `/home/[account]/workpacks/delegated/substances`,
    accountHseqPermitNew: `/home/[account]/hseq/permits/new`,
    accountHseqPermit: `/home/[account]/hseq/permits/[permitId]`,
    // PAY-3345: punchlist walks list and report.
    accountHseqWalks: `/home/[account]/hseq/walks`,
    accountHseqWalk: `/home/[account]/hseq/walks/[walkId]`,
    // PAY-3916: account-wide site map. Project tabs link here with ?project=.
    accountHseqMap: `/home/[account]/hseq/map`,
    // PAY-3598: HSE statistics (frequency rates, exposure hours, targets).
    accountHseqStatistics: `/home/[account]/hseq/statistics`,
    accountHseqShared: `/home/[account]/hseq/shared`,
    accountHseqSharedIssue: `/home/[account]/hseq/shared/[issueId]`,
    accountWorkpackTemplates: `/home/[account]/workpacks/templates`,
    accountMessaging: `/home/[account]/messaging`,
    accountSmsInbox: `/home/[account]/sms`,
    accountSmsCompose: `/home/[account]/sms/compose`,
    accountSmsOutbox: `/home/[account]/sms/outbox`,
    accountSmsUsage: `/home/[account]/sms/usage`,
    accountSmsTemplates: `/home/[account]/sms/templates`,
    accountSmsGroups: `/home/[account]/sms/groups`,
    accountWorkpackInstances: `/home/[account]/workpacks/instances`,
    accountWorkpacksIncoming: `/home/[account]/workpacks/incoming`,
    // PAY-963 Task 7: the GC-side "Workpacks assigned to us" org view.
    accountWorkpacksAssigned: `/home/[account]/workpacks/assigned`,
    // PAY-1057 Slice C (C3): the SUB-side "Workpacks delegated to us" view —
    // the mirror image of accountWorkpacksAssigned, run under the sub's own
    // [account] slug.
    accountWorkpacksDelegated: `/home/[account]/workpacks/delegated`,
    accountWorkpacksSettings: `/home/[account]/workpacks/settings`,
    // PAY-1057 Slice B (B3): the GC-side "Linked organisations" directory.
    accountWorkpacksOrganisations: `/home/[account]/workpacks/organisations`,
    accountSubcontractors: `/home/[account]/subcontractors`,
    accountUsage: `/home/[account]/usage`,
    supplierOnboarding: `/supplier/onboarding`,
    supplierHome: '/home/supplier',
    supplierPurchaseOrders: '/home/supplier/purchase-orders',
    supplierInvoices: '/home/supplier/invoices',
    supplierPortals: '/home/supplier/portals',
    accountMarketplace: `/home/[account]/marketplace`,
    accountMarketplaceProfile: `/home/[account]/marketplace/profile`,
    accountMarketplaceOfferings: `/home/[account]/marketplace/offerings`,
    accountMarketplaceRequests: `/home/[account]/marketplace/requests`,
    accountMarketplacePurchaseOrders: `/home/[account]/marketplace/purchase-orders`,
    accountMarketplaceNewRequest: `/home/[account]/marketplace/requests/new`,
    joinTeam: '/join',
    // PAY-1057 Slice B (B4): the sub-side org-link accept surface. Top-level
    // (not under /home/[account]) — the accepting user isn't yet a member of
    // any account tied to this flow when they land here. Must match the
    // literal path `apps/web/lib/workpacks/adapters/pay-org-link-notifier.ts`
    // builds into the invite email (`/workpack-org-links/accept?linkId=...`).
    workpackOrgLinkAccept: '/workpack-org-links/accept',
    // PAY-2739 F5: unified org-link accept page (SubHub + workpack). The
    // SubHub notifier builds invite/nudge/changes-requested CTAs from this
    // path. D1 redirects `/workpack-org-links/accept` here.
    orgLinkAccept: '/org-links/accept',
  },
} satisfies z.output<typeof PathsSchema>);

export default pathsConfig;
